import type { formatters, model } from '@neo4j/graph-schema-utils';

import type { DataSourceLocation, ForeignKey } from './data-model.types';

export type GraphSchemaExtensionsRepresentationJsonStruct = {
  nodeKeyProperties: NodeKeyPropertyJsonStruct[];
};

export type NodeKeyPropertyJsonStruct = {
  node: { $ref: string };
  keyProperty: { $ref: string };
};

export type TableSchemaLocalFieldJsonStruct = {
  name: string;
  recommendedType: { type: model.PrimitivePropertyTypes };
  sample: string;
};

export type TableSchemaCloudFieldJsonStruct = {
  name: string;
  rawType: string;
  recommendedType?: { type: model.PrimitivePropertyTypes };
  supportedTypes?: { type: model.PrimitivePropertyTypes }[];
};

export type TableSchemaFieldJsonStruct = TableSchemaLocalFieldJsonStruct | TableSchemaCloudFieldJsonStruct;

export const isTableSchemaLocalFieldJsonStruct = (
  schema: TableSchemaFieldJsonStruct,
): schema is TableSchemaLocalFieldJsonStruct => {
  return 'sample' in schema && !('rawType' in schema);
};

export type TableSchemaJsonStruct = {
  name: string;
  expanded: boolean;
  fields: TableSchemaFieldJsonStruct[];
  primaryKeys?: string[];
  foreignKeys?: ForeignKey[];
};

export type DataSourceSchemaJsonStruct = {
  type: DataSourceLocation;
  tableSchemas: TableSchemaJsonStruct[];
};

export type MappingFilterJsonStruct = {
  fieldName: string;
  exactMatch: string;
};

export type PropertyMappingJsonStruct = { property: { $ref: string }; fieldName: string };

export type NodeMappingJsonStruct = {
  node: { $ref: string };
  tableName: string;
  propertyMappings: PropertyMappingJsonStruct[];
  mappingFilter?: MappingFilterJsonStruct;
};

export type RelationshipMappingJsonStruct = {
  relationship: { $ref: string };
  tableName: string;
  fromMapping?: { fieldName: string };
  toMapping?: { fieldName: string };
  propertyMappings: PropertyMappingJsonStruct[];
  mappingFilter?: MappingFilterJsonStruct;
};

export type GraphMappingRepresentationJsonStruct = {
  dataSourceSchema: DataSourceSchemaJsonStruct;
  nodeMappings: NodeMappingJsonStruct[];
  relationshipMappings: RelationshipMappingJsonStruct[];
};

export type ConfigurationsJsonStruct = {
  idsToIgnore: string[];
};

export type IndexesJsonStruct = formatters.json.types.IndexJsonStruct;
export type ConstraintsJsonStruct = formatters.json.types.ConstraintJsonStruct;

export type DataModelJsonStruct = {
  version: string;
  graphSchemaRepresentation: formatters.json.types.GraphSchemaRepresentationJsonStruct;
  graphSchemaExtensionsRepresentation: GraphSchemaExtensionsRepresentationJsonStruct;
  graphMappingRepresentation: GraphMappingRepresentationJsonStruct;
  configurations: ConfigurationsJsonStruct;
};
